import { useSyncExternalStore } from "react";
import { isOnline, subscribe } from "../../api/connectivity";
export function useOnlineStatus() {
    return useSyncExternalStore(subscribe, isOnline, () => true);
}
